<template>
  <div>
    <v-row class="detail-wrapper work-overtime">
      <v-col cols="12" class="px-6 py-0">
        <!-- 현황 타이틀  -->
        <sta-title></sta-title>
        <!-- 현황 카드 -->
        <work-over-time-sta-card></work-over-time-sta-card>
      </v-col>
    </v-row>

    <v-row class="title-wrap">
      <v-col cols="12" class="detail-title d-flex justify-space-between"
        ><span>휴가신청 및 사용</span>
        <v-btn
          elevation="0"
          height="38"
          class="mt-n2 btn-year"
          @click="searchYearSheet = !searchYearSheet"
        >
          {{ currYear }}년
          <v-icon class="ml-1" size="24" color="#9ca3ab"
            >mdi-chevron-right</v-icon
          >
        </v-btn>
      </v-col>
    </v-row>
    <!-- 연장근무보상시간 리스트 -->
    <work-over-time-sta-list
      v-bind:searchParam="currYear"
    ></work-over-time-sta-list>

    <!---------------------------------------------------------------------------->
    <!-- 조회연도 선택 -->
<!--    <bottom-select-->
<!--      :flag="searchYearSheet"-->
<!--      :list="yearList"-->
<!--      :title="selecttitle"-->
<!--      @selectItem="selectSearchYear"-->
<!--    ></bottom-select>-->
    <v-bottom-sheet v-if="searchYearSheet" v-model="searchYearSheet">
      <bottom-sheet :title="selecttitle" :default="currYear" :items="yearList" @selectItem="selectSearchYear"></bottom-sheet>
    </v-bottom-sheet>
  </div>
</template>

<script>
/* 연장근무보상시간 */
import StaTitle from '@/components/status/StaTitle.vue';
import WorkOverTimeStaCard from '@/components/status/WorkOverTimeStaCard.vue';
import WorkOverTimeStaList from '@/components/status/WorkOverTimeStaList.vue';
import BottomSelect from '@/components/application/form/BottomSelect.vue';
import { getYearList } from '@/utils/common/dateUtil';
import dayjs from 'dayjs';
import BottomSheet from "@/components/application/form/BottomSheet.vue";

export default {
  data: () => ({
    searchYearSheet: false,
    selecttitle: '연도선택',
    yearList: [],
    currYear: '',
    selected : ''
  }),
  methods: {
    /* 조회연도 선택 */
    selectSearchYear(data) {
      // 조회연도 콤보 닫기
      this.searchYearSheet = !this.searchYearSheet;

      if (this.currYear !== data.codeNm) {
        this.currYear = data.codeNm;
        // 공통 스피너 ON
        this.$store.commit('SPINNER/ON_COMMON_SPINNER', 'black');
      }
    },
  },
  created() {
    // 공통 스피너 ON
    this.$store.commit('SPINNER/ON_COMMON_SPINNER', 'black');

    this.yearList = getYearList();
    this.currYear = dayjs().format('YYYY');
  },
  components: {
    BottomSheet,
    StaTitle,
    WorkOverTimeStaCard,
    WorkOverTimeStaList,
    BottomSelect,
  },
};
</script>

<style>
/* _list.scss 참고 */
.v-btn.btn-detail:not(.v-btn--round).v-size--default {
  min-width: min-content;
}
.detail-wrapper.work-overtime {
  background-image: url('../../../assets/img/bg_detail_workOvertime.png');
}
</style>
